/**
 * @ngdoc service
 * @name common.service:BannersService
 * @description
 * A service that manages the Banners.
 * It keeps an array of active banners which will update on user request. Also keeps an array of queue array
 * of waiting banners to be shown when dependecies has been resolved.
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('BannersService', BannersService);

    BannersService.$inject = ['$timeout', 'mdUtils', 'CommonServices', 'DUTTI_CONS', 'ItxScreenSizeSvc', 'AkamaiDateSvc', 'ItxUtilsFct'];

    function BannersService($timeout, mdUtils, CommonServices, DUTTI_CONS, ItxScreenSizeSvc, AkamaiDateSvc, ItxUtilsFct) {
        var _this = this;
        // Banners currently opened.
        _this.activeBanners = [];
        // Banners in waiting list
        _this.bannersInQueue = [];
        // Only 2 banners at a time.
        _this.maxSimultaneousBanners = ItxScreenSizeSvc.isDeviceMobile() ? 1 : 2;

        _this.bannerTypes = {
            cookies: {
                value: 'cookies',
                type: 1
            },
            ask: {
                value: 'LAST_GEOBLOCKING',
                type: 2
            },
            redirect: {
                value: 'redirect',
                type: 2
            },
            downloadApp: {
                value: 'downloadApp',
                type: 3
            },
            marketing: {
                value: 'marketing',
                type: 4
            },
            buy: {
                value: 'buy',
                type: 5
            }
        };

        var service = {
            openBanner: openBanner,
            closeBanner: closeBanner,
            isBannerOpen: isBannerOpen,
            closeAll: closeAll,
            banners: _this.bannerTypes,
            verifyGeoblockingStore: _verifyGeoblockingStore,
            saveLastStore: _saveLastStore,
            isWebApp: _isWebApp,
            verifyBuyCookie: _verifyBuyCookie,
            canIOpenBannersInApollo: canIOpenBannersInApollo,
            isSomeBannerInQueue: isSomeBannerInQueue,
            activateApolloBanners: activateApolloBanners
        };

        return service;

        /**
         * @ngdoc method
         * @name isBannerOpen
         * @methodOf
         * @description
         * Check if given banner is in the array of active banners.
         * @returns {boolean} is banner open
         */
        function isBannerOpen(banner) {
            return _.indexOf(_this.activeBanners, banner) != -1;
        }

        /**
         * @ngdoc method
         * @name isBannerOpen
         * @methodOf
         * @description
         * Check if given banner is in the array of active banners.
         * @returns {boolean} is banner open
         */
        function canIOpenBannersInApollo() {
            if (_this.activeBanners.length) {
                if (_this.activeBanners.includes('marketing')) {
                    const isActive = document.getElementById('itx-popup-mkt-cmp');
                    return isActive ? false : true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }

        function isSomeBannerInQueue() {
            return _this.bannersInQueue.length;
        }

        function activateApolloBanners() {
            const eventApolo = new CustomEvent('active_banners_apolo', { detail: {} });
            document.dispatchEvent(eventApolo);
        }

        /**
         * @ngdoc method
         * @name openBanner
         * @methodOf common.service:BannersService
         * @description
         * Open the banner only if has not been closed before and satisfy preset requirements.
         */
        function openBanner(banner) {
            if (banner === 'LAST_GEOBLOCKING') {
                var result = _verifyGeoblockingStore();
                if (!result) {
                    return false;
                }
            }

            if (_satisfyRestrictions(banner)) {
                _this.activeBanners.push(banner);
                return true;
            }
            return false;
        }

        /**
         * @ngdoc method
         * @name verifyGeoblockingStore
         * @methodOf common.service:BannersService
         * @description
         * If banner geoblocking has been rejected, don't show (current store).
         */
        function _verifyGeoblockingStore() {
            var lastMarketVisited = localStorage.getItem('LAST_STORE_GEOBLOCKING');
            var hasRejectedBanner = localStorage.getItem('last-geoblocking-rejected');
            
            // Verifico mercado
            if(lastMarketVisited){
                var lastMarket = JSON.parse(lastMarketVisited);
                var lastStoreId = lastMarket && lastMarket.storeAndLanguage && lastMarket.storeAndLanguage.storeId;
                var actualStoreId = inditex.iStoreId;

                return !hasRejectedBanner && actualStoreId !== lastStoreId;
            }
            if (hasRejectedBanner) {
                return false;
            }
            return true;
        }

        /**
         * Cierra el banner pasado por parámetro.
         */
        function closeBanner(banner, hideBannerNextTime) {
            _this.activeBanners = _.filter(_this.activeBanners, function (activeBanner) {
                return activeBanner != banner;
            });

            if (_this.bannersInQueue.length > 0) {
                $timeout(function () {
                    _openBannerInQueue();
                }, 2000);
            }

            if (hideBannerNextTime) {
                _hideBannerNextTime(banner);
            }
        }

        /**
         * @ngdoc method
         * @name closeAll
         * @methodOf common.service:BannersService
         * @description
         * Close all banners
         */
        function closeAll() {
            _this.activeBanners = [];
        }

        /**
         * @ngdoc method
         * @name _hideBannerNextTime
         * @methodOf common.service:BannersService
         * @description
         * Set local storage banner to not show it next time.
         */
        function _hideBannerNextTime(banner) {
            inditex.setLocalStorage(banner, true);
        }

        /**
         * @ngdoc method
         * @name _isBannerClosed
         * @methodOf common.service:BannersService
         * @description
         * If banner doesnt exists in local storage will return null.
         */
        function _isBannerClosed(banner) {
            return inditex.getLocalStorage(banner);
        }
        /**
         * @ngdoc method
         * @name _insertInQueue
         * @methodOf common.service:BannersService
         * @description
         * Insert banner into the queue
         */
        function _insertInQueue(banner) {
            if (_this.bannersInQueue.indexOf(banner) == -1) {
                _this.bannersInQueue.push(banner);
            }
        }
        /**
         * @ngdoc method
         * @name _openBannerInQueue
         * @methodOf common.service:BannersService
         * @description
         * Move banners from queue to the active banners.
         */
        function _openBannerInQueue() {
            if (_this.activeBanners.length < _this.maxSimultaneousBanners) {
                for (let i = 0; i < _this.bannersInQueue.length; i++) {
                    var selectedBanner = _this.bannersInQueue[i];
                    var bannerOpened = openBanner(selectedBanner);
                    if (bannerOpened) {
                        _this.bannersInQueue = _.filter(_this.bannersInQueue, function (
                            queueBanner
                        ) {
                            return queueBanner != bannerOpened;
                        });
                        break;
                    }
                }
            }
        }

        function canOpenMarketing() {
            if (
                localStorage.getItem('last-geoblocking-rejected') ||
                localStorage.getItem('LAST_GEOBLOCKING') === 'true' ||
                localStorage.getItem('redirect') === 'true'
            ) {
                return true;
            }
        }

        /**
         * @ngdoc method
         * @name _satisfyRestrictions
         * @methodOf common.service:BannersService
         * @description
         * Check the following:
         * - Max quantity of banners opened has reached
         * - If given banner needs other banners to be closed before open it.
         * - If its restricted by page.
         * @returns {boolean} satisfy restriction
         */
        function _satisfyRestrictions(banner) {
            if (_this.activeBanners.length == _this.maxSimultaneousBanners) {
                _insertInQueue(banner);
                return false;
            }

            if (banner === 'marketing') {
                var result = canOpenMarketing();
                if (!result) {
                    _insertInQueue(banner);
                    return false;
                }
            }

            var selectedBanner = _this.bannerTypes[banner];

            if (
                selectedBanner &&
                selectedBanner.restrictedBy &&
                selectedBanner.restrictedBy.length > 0
            ) {
                var bannersClosed = true;

                for (var i = 0; i < selectedBanner.restrictedBy.length; i++) {
                    var banners = _.filter(_this.bannerTypes, function (bannerType) {
                        return bannerType.type == selectedBanner.restrictedBy[i];
                    });

                    bannersClosed = _.find(banners, function (item) {
                        return _isBannerClosed(item.value);
                    });

                    if (!bannersClosed) {
                        _insertInQueue(banner);
                        break;
                    }
                }
                return bannersClosed;
            }

            return true;
        }

        /**
         * @ngdoc method
         * @name verifyBuyCookie
         * @methodOf common.service:BannersService
         * @description
         * If cookie registered_user_cookie is enbable show buy banner.
         */

        function _verifyBuyCookie() {
            const cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
            const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);
            if (isCookieGroupAllowed) {
                let cookieName = 'registered_user_cookie';
                let cookie = inditex.readCookie(cookieName);

                if (cookie != null) {
                    let cookieData = JSON.parse(cookie);
                    AkamaiDateSvc.getDate().then((akamaiDate) => {
                        if (dateParseValidation(cookieData.date, akamaiDate)) {
                            openBanner(_this.bannerTypes.buy.value);
                        }
                    });
                }
            }
        }

        function dateParseValidation(orderDate, akamaiDate) {
            const tz = ItxUtilsFct.getTimeZone();
            let orderDateAkamai = moment.tz(orderDate, 'YYYY-MM-DD-HH:mm:ss', tz);
            orderDateAkamai.add(1, 'days');
            let isAfter = akamaiDate.isAfter(orderDateAkamai.format());
            if (isAfter) {
                return true;
            }
            return false;
        }

        function _saveLastStore() {
            // WorldwideModels.LastMarketVisited
            let lastMarketVisited = {
                storeAndLanguage: {
                    storeId: inditex.iStoreId,
                    storeCode: inditex.iCountryCode,
                    storeName: null,
                    languageId: inditex.iLangId,
                    languageCode: null,
                    languageName: null,
                },
                saveGeoblockingStore: true,
                section: inditex.getLocalStorage('LAST_SECTION'),
            };
            
            inditex.setLocalStorage('LAST_STORE_GEOBLOCKING', JSON.stringify(lastMarketVisited));
        }

        function _isWebApp() {
            if (mdUtils.isWebapp()) {
                $('.md-banners').hide();
            }
        }
    }
})();
